import React, { useEffect, useState } from 'react';
import { Button, Drawer, Field, Input, Select, Table } from '@itds/elements';
import { format } from 'date-fns';
import { useParams } from 'react-router-dom';
import Api from '@carrier/utils/Api';

function Investments() {
  const params = useParams();

  const [investment, setInvestment] = useState(null);
  const [investments, setInvestments] = useState([]);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  useEffect(function loadData() {
    async function getInvestments() {
      try {
        const response = await Api.loadInvestments(params.version_id);
        setInvestments(prev => ({ ...(prev || {}), ...(response?.data || {}) }));
      } catch (error) {
        console.error('Error loading investments:', error);
      }
    }
    getInvestments();
  }, [params.version_id]);

  
  function getValue(eOrVal) {
    return eOrVal?.target?.value ?? eOrVal?.value ?? eOrVal;
  }

  function handleInputChange(name) {
    return function onChange(eOrVal) {
      const v = getValue(eOrVal);
      setInvestment(prev => ({ ...prev, [name]: v }));
    };
  }


  function handleMvaChange(val) {
    setInvestment(prev => ({ ...prev, mva: String(getValue(val)) === 'true' }));
  }

  function handleSave() {   
    if (!investment?.id) {
        Api.saveNewInvestment(investment).then(() => {
            setIsDrawerOpen(false);
        }).catch((error) => {
            console.error('Error saving investment:', error);
        });
    } else {
        Api.saveEditInvestment(investment).then(() => {
            setIsDrawerOpen(false);
        }).catch((error) => {
            console.error('Error saving investment:', error);
        });
    }
  }

  function openCreateNewDrawer() {
    setInvestment(null);
    setIsDrawerOpen(true);
  }

  function closeDrawer() {
    setIsDrawerOpen(false);
  }

  function onRowClick(row) {
    setInvestment(row);
    setIsDrawerOpen(true);
  }

  function getColumns() {
    return [
      { id: 'product_name', label: 'Product Name', render: row => row.product_name || 'N/A' },
      { id: 'rate_term', label: 'Rate Term', render: row => row.intrateter || 'N/A' },
      { id: 'rate', label: 'Rate', render: row => row.init_rate || 'N/A' },
      {
        id: 'states_approved',
        label: 'States approved',
        render: row =>
          Array.isArray(row.mgir_states)
            ? row.mgir_states.join(', ')
            : row.mgir_states || 'N/A'
      },
      { id: 'bonus', label: 'Bonus', render: row => ((row.bonus_pct || row.bonus_len || row.bonus_type) ? 'true' : 'false') },
      { id: 'mva', label: 'MVA (true/false)', render: row => (row.mva ? 'true' : 'false') },
      { id: 'rop', label: 'ROP', render: row => (row.rop ? 'true' : 'false') },
      {
        id: 'updated_at',
        label: 'Date Updated',
        render: row => (row.updated_at ? format(new Date(row.updated_at), 'MM/dd/yyyy') : 'N/A')
      }
    ];
  }

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 30 }}>
        <Button style={{}} onClick={openCreateNewDrawer}>New Investment</Button>
      </div>

      <Table columns={getColumns()} data={investments} onRowClick={onRowClick} />

      <Drawer
        alignRight
        title={investment?.id ? 'Edit Investment' : 'New Investment'}
        show={isDrawerOpen}
        onClose={closeDrawer}
        footer={<Button style={{}} onClick={handleSave}>{investment?.id ? 'Update Investment' : 'Create Investment'}</Button>}
      >
        <Field label="Rate Term" style={{}}>
          <Input value={investment?.intrateter} onChange={handleInputChange('intrateter')} />
        </Field>
        <Field label="Minimum contribution" style={{}}>
          <Input value={investment?.minimum_con || ''} onChange={handleInputChange('minimum_con')} />
        </Field>
        <Field label="Rate" style={{}}>
          <Input value={investment?.init_rate || ''} onChange={handleInputChange('rate')} />
        </Field>
        <Field label="Guaranteed minimum rate" style={{}}>
          <Input value={investment?.min_grate || ''} onChange={handleInputChange('min_grate')} />
        </Field>
        <Field label="States approved" style={{}}>
          <Input value={investment?.mgir_states || ''} onChange={handleInputChange('mgir_states')} />
        </Field>
        <Field label="Bonus Type" style={{}}>
          <Input value={investment?.bonus_type || ''} onChange={handleInputChange('bonus_type')} />
        </Field>
        <Field label="Bonus Term" style={{}}>
          <Input value={investment?.bonus_len} onChange={handleInputChange('bonus_len')} />
        </Field>
        <Field label="Bonus Percentage" style={{}}>
          <Input value={investment?.bonus_pct} onChange={handleInputChange('bonus_pct')} />
        </Field>
        <Field label="MVA" style={{}}>
          <Select
            style={{}}
            value={investment?.mva ? 'true' : 'false'}
            onChange={handleMvaChange}
            options={[{ value: 'true' }, { value: 'false' }]}
          />
        </Field>
        <Field label="ROP" style={{}}>
          <Select
            style={{}}
            value={investment?.rop ? 'true' : 'false'}
            onChange={handleInputChange('rop')}
            options={[{ value: 'true' }, { value: 'false' }]}
          />
        </Field>
        <Field label="Maximum Contribution" style={{}}>
          <Input value={investment?.maximum_con || ''} onChange={handleInputChange('maximum_con')} />
        </Field>
        <Field label="Band description" style={{}}>
          <Input value={investment?.band_desc || ''} onChange={handleInputChange('band_desc')} />
        </Field>
        <Field label="Inactive" style={{}}>
          <Select
            style={{}}
            value={investment?.is_live ? 'true' : 'false'}
            onChange={val => setInvestment(prev => ({ ...prev, is_live: String(getValue(val)) === 'true' }))}
            options={[{ value: 'true' }, { value: 'false' }]}
          />
        </Field>
      </Drawer>
    </>
  );
}

export default Investments;
